export default __webpack_public_path__ + "static/media/criss-cross.132504dc.svg";